import BaseApiService from './BaseApiService.js';

class StudentBusService extends BaseApiService {
  // ✅ Get allocated bus location
  async getMyBusLocation() {
    return this.makeRequest('/api/student/bus/location');
  }
}

const studentBusService = new StudentBusService();
export default studentBusService;
